import { HttpParams } from '@angular/common/http';
import * as _ from 'lodash';
import { CustomHttpParamEncoder } from './http-parameter-encoder';

export function toParams(query: Record<string, any> = {}): HttpParams {
    return _.reduce(query, (acc: HttpParams, value, key) => {
        // do nothing on undefined values
        if (!value) {
            return acc;
        }
        return acc.set(key, value.toString());
    }, new HttpParams({encoder : new CustomHttpParamEncoder()}));
}
